import { useState } from "react"
import { Button } from "@components/ui/buttons/Button"

export const KmlUploadDialog = ({ showDialog, onSubmit, fileName }) => {
    const [epsilon, setEpsilon] = useState(0.0001);

    const handleSubmit = () => {
        onSubmit(epsilon);
        showDialog(false);
    }

    return (
        <>
            <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white p-8 rounded-lg max-w-md mx-4 flex flex-col items-center">
                    <p className="text-md text-center font-bold">{fileName}</p>
                    <div className="mt-4 text-sm text-gray-700">
                        <p className="font-bold">Simplification Tolerance (Epsilon)</p>
                        <p className="mt-1">
                            Controls how much the line geometry from your KML/KMZ file is simplified.
                            A smaller value preserves more detail (more points), while a larger value
                            simplifies the line further (fewer points). The default of 0.0001 works
                            well for most pipelines.
                        </p>
                    </div>
                    <div className="mt-4 w-full">
                        <input
                            type="number"
                            value={epsilon}
                            onChange={(e) => {
                                const val = parseFloat(e.target.value);
                                setEpsilon(isNaN(val) ? 0.0001 : val);
                            }}
                            step="0.0001"
                            min="0"
                            className="border border-gray-300 rounded px-3 py-2 w-full text-sm"
                        />
                    </div>
                    <div>
                        <div className='flex mt-5 space-x-10'>
                            <Button
                                variant="success"
                                onClick={handleSubmit}
                                className='w-max mr-2'
                            >
                                Convert
                            </Button>
                            <Button
                                variant="danger"
                                onClick={() => showDialog(false)}
                                className='w-max mr-2'
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
